module.exports = __webpack_public_path__ + "5d27c5241488c9c44f0e9d41b48cd558-811_1_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/eightOneOne/assets/811_1_2x.png
// module id = 614
// module chunks = 0